import { PLATFORM_ROUTES } from '@frontend/routing';
import { useLocation } from 'react-router-dom';
import {
  GuestButtonWrapper,
  Menu,
  UserIconButton,
  UserNavbar,
} from './HeaderDesktopMenu.css';
import { HEADER_VARIANTS } from '../PlatformHeader.types';
import IHeaderDesktopMenu from './HeaderDesktopMenu.types';
import UserBox from '../UserBox/UserBox';
import UserNotificationsDesktop from '../UserNotifications/UserNotificationsDesktop/UserNotificationsDesktop';
import UserMenu from '../UserMenu/UserMenu';
import {
  LoginButton,
  OpenVariantFormDrawerButton,
  SignUpButton,
} from '@customer-platform-shared/components/PlatformHeader/PlatformHeaderButtons';

export default function HeaderDesktopMenu({
  closeElement,
  currentOpenElement,
  isDropdownMenuOpen,
  isNotificationsOpen,
  openDropdownMenu,
  openNotifications,
  openFormDrawer,
  openLogoutModal,
  switchOperationMode,
  openProfileDrawer,
  variant,
}: IHeaderDesktopMenu) {
  const { pathname } = useLocation();
  const pathnameIsLogin = pathname === PLATFORM_ROUTES.login;

  return (
    <UserNavbar>
      {variant === HEADER_VARIANTS.GUEST && (
        <GuestButtonWrapper>
          {pathnameIsLogin ? <SignUpButton /> : <LoginButton />}
        </GuestButtonWrapper>
      )}

      {[HEADER_VARIANTS.BUYER, HEADER_VARIANTS.SELLER].includes(variant) && (
        <>
          <OpenVariantFormDrawerButton
            variant={variant}
            openFormDrawer={openFormDrawer}
          />

          <UserNotificationsDesktop
            isNotificationsOpen={isNotificationsOpen}
            closeElement={closeElement}
            openNotifications={openNotifications}
            currentOpenElement={currentOpenElement}
          />

          <UserIconButton
            id="user-header.icon-button.open-user-box"
            data-testid="user-dropdown-button"
            onClick={openDropdownMenu}
          >
            <UserBox open={isDropdownMenuOpen} variant={variant} />
          </UserIconButton>
          <Menu
            anchorEl={
              isDropdownMenuOpen
                ? (currentOpenElement as HTMLElement)
                : undefined
            }
            onClose={closeElement}
            open={isDropdownMenuOpen}
          >
            <UserMenu
              variant={variant}
              switchOperationMode={switchOperationMode}
              openProfileDrawer={openProfileDrawer}
              openLogoutModal={openLogoutModal}
            />
          </Menu>
        </>
      )}
    </UserNavbar>
  );
}
